export const GRID_COLUMNS = 12;

export const GRID_CONTAINER_WIDTH = 1170;

export const GRID_CONTAINER_WIDTH_PX = `${GRID_CONTAINER_WIDTH}px`;

export const isUnderColumnCount = (columns, width) => (
  width < (GRID_CONTAINER_WIDTH * (columns / GRID_COLUMNS))
);
